import type { Ref } from 'vue'
import { ref } from 'vue'
import { getSafeJSONValue } from '@app/utils/local-storage'

/**
 * Vue composable to load the draft of a remark from localstorage.
 *
 * @param id The id of the remark, if the draft is for an edit
 * @param ledgerId The ledger id of the remark
 * @param ownerType The owner type, if the draft is for a new remark
 * @param ownerId The owner id, if the draft is for a new remark
 * @returns Both the value and a function to reload the value from localstorage
 */
export default function useRemarkDraft({
  id,
  ledgerId,
  ownerType,
  ownerId,
}: {
  id?: number
  ledgerId: number
  ownerType?: string
  ownerId?: number
}): { message: Ref<string | null>; load: () => void } {
  const parentType = id ? 'edit' : 'new'
  const subpath = id ? `remark/${id}` : `${ownerType}/${ownerId}`
  const path = `remarkDraft/${parentType}/${ledgerId}/${subpath}`

  const message: Ref<string | null> = ref(null)

  function load(): void {
    const valueWithTTL = getSafeJSONValue<{ value: string }>(path)

    if (valueWithTTL) {
      message.value = valueWithTTL.value
    } else {
      message.value = null
    }
  }
  load()

  return { message, load }
}
